import React from 'react';
import Icon from '../Icon';
import Title from '../Title';
import ContentBox from '../ContentBox';
import Button from '../Button';
import './PageVariant.css';
import withTheme from '../../hocs/withTheme';
import { getClassNames } from '../../utils';

type PageVariantProps = {
    children?: React.ReactNode;
    primaryButtonLabel?: string | null;
    primaryButtonProps?: Record<string, unknown>;
    onPrimaryButtonClick?: () => void;
    className?: string;
    horizontal?: boolean;
    title: string;
    type: string;
    message: string;
    actionButtonLabel: string;
    onActionButtonClick: () => void;
};

const PageVariantBase = ({
    children = null,
    primaryButtonLabel = null,
    primaryButtonProps = {},
    onPrimaryButtonClick = () => {},
    className = '',
    horizontal = false,

    title,
    type,
    message,
    actionButtonLabel,
    onActionButtonClick,
}: PageVariantProps) => (
    <div className="PageVariant wrapper">
        <div className="main">
            <div className="justify-content-center">
                <ContentBox underline={false} className={type}>
                    <Icon type={type} size={32} />
                    <Title type={2}>{title}</Title>
                    <p>{message}</p>
                    <div className={getClassNames(className, 'PageVariant-buttons', { 'PageVariant-buttons-horizontal': horizontal })}>
                        {primaryButtonLabel && (
                            <Button
                                type="primary"
                                onClick={onPrimaryButtonClick}
                                {...primaryButtonProps}
                            >
                                {primaryButtonLabel}
                            </Button>
                        )}
                        {children}
                        {actionButtonLabel && (
                            <Button
                                type="secondary"
                                onClick={onActionButtonClick}
                            >
                                {actionButtonLabel}
                            </Button>
                        )}
                    </div>
                </ContentBox>
            </div>
        </div>
    </div>
);

export const PageVariant = withTheme(PageVariantBase);
